module.exports = __webpack_public_path__ + "img/SALT-alt.f35e4a12.svg";